import React from 'react';

// Styles & Assets
import styles from './EditCasesColumnsDialog.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import CheckboxGrid from '../../UI/CheckboxGrid/CheckboxGrid';

// Interface
import { Column } from '../../../interfaces/Columns';
import { CaseHistory } from '../../../interfaces/Patient';
interface Props {
    columns: Column<CaseHistory>[]
    changeVisibility: (id: number) => void
    modalShow?: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditCasesColumnsDialog: React.FC<Props> = ({ columns, changeVisibility, modalShow }) => {

    const { t } = useTranslation();

    return (
        <div className='dialog'>
            <h1 className='dialogTitle' style={{ marginBottom: '8px' }}>
                {t('select_data')}
            </h1>
            <h2 className='dialogSubTitle'>
                {t('cases_history')}
            </h2>
            <div className={styles.gridContainer}>
                <CheckboxGrid
                    columns={columns}
                    toggleVisibility={changeVisibility}
                />
            </div>
            <div className={styles.buttonsContainer}>
                <button className='button' onClick={() => modalShow?.(false)}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default EditCasesColumnsDialog;